@if(config.type == 'label'){
<span
  [class]="`rounded-2 fs-7 px-3 fw-semibold py-1 text-uppercase text-${config.color}-${contraryThemes[config.theme!]} bg-${config.color}-${config.theme}`"
  [style]="`${config.size? `font-size: ${textSizes[config.size]}px`  : `font-size: ${textSizes.sm}px` }`"
  >{{ config.label.key | translate : config.label.params }}</span
>
} @else{
<span
  [class]="`badge rounded-3 text-${config.color}-${contraryThemes[config.theme!]} bg-${config.color}-${config.theme}`"
  style="padding: 11px 9px 11px 11px"
>
  <icon
    [class]="'d-flex justify-content-center'"
    [icon]="config.icon"
    [size]="`${config.size? iconSizes[config.size] : ''}`"
  />
</span>
}